import { forwardRef, useRef, useState } from 'react';
import { clsx } from 'clsx';

interface FileUploadProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  className?: string;
  tiny?: boolean;
  onFileChange?: (file: File | null) => void;
  accept?: string;
  placeholder?: string;
}

export const FileUpload = forwardRef<HTMLInputElement, FileUploadProps>(
  function FileUpload(
    {
      className,
      tiny = false,
      onFileChange,
      accept = '.pdf,.doc,.docx',
      placeholder = 'Aucun fichier sélectionné',
      ...props
    },
    ref
  ) {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [fileName, setFileName] = useState<string>('');

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0] || null;
      setFileName(file?.name || '');
      onFileChange?.(file);
    };

    const handleButtonClick = () => {
      fileInputRef.current?.click();
    };

    return (
      <div className="relative">
        <input
          ref={fileInputRef}
          type="file"
          accept={accept}
          onChange={handleFileChange}
          className="hidden"
          {...props}
        />
        <div
          onClick={handleButtonClick}
          className={clsx(
            // Base styles
            "w-full px-4 py-4 rounded border border-gray-300 text-sm font-normal text-gray-700 box-border cursor-pointer",
            "flex items-center justify-between",
            "hover:border-primary transition-colors",
            "focus-within:outline-none focus-within:ring-2 focus-within:ring-primary focus-within:border-primary",
            // Hauteur par défaut (52px)
            "h-12",
            // Variant tiny (40px height)
            tiny && "!h-10",
            className
          )}
        >
          <span className={clsx(
            fileName ? "text-gray-700" : "text-gray-500 italic"
          )}>
            {fileName || placeholder}
          </span>
          <span className="text-primary font-medium">
            Parcourir
          </span>
        </div>
      </div>
    );
  }
);
